export default "__VITE_ASSET__3b14cf5b__"